import React from 'react'
import {
  CmsSectionTextColorProvider,
  getCmsSectionShellClassName,
  getCmsSectionShellStyle,
} from './cms-section-text-content'

type CMSSectionShellProps = {
  id: string
  title?: string
  titleTestId?: string
  children?: React.ReactNode
  className?: string
  backgroundColor?: string
}

const CMSSectionShell = ({
  id,
  title,
  titleTestId,
  children,
  className,
  backgroundColor,
}: CMSSectionShellProps) => {
  const hasBody = React.Children.count(children) > 0

  return (
    <section
      id={id}
      className={getCmsSectionShellClassName(
        `opportunity-overview-panel opportunity-cms-section-card${
          className ? ` ${className}` : ''
        }`,
        backgroundColor,
      )}
      style={getCmsSectionShellStyle(backgroundColor)}
      data-testid={titleTestId}
    >
      {title ? (
        <div className='opportunity-cms-section-header'>
          <h2 className='opportunity-cms-section-title h5-heading'>{title}</h2>
        </div>
      ) : null}
      {hasBody ? (
        <CmsSectionTextColorProvider backgroundColor={backgroundColor}>
          <div className='opportunity-cms-section-body'>{children}</div>
        </CmsSectionTextColorProvider>
      ) : null}
    </section>
  )
}

export { CMSSectionShell }
